import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-action-call',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './action-call.component.html',
  styleUrl: './action-call.component.scss',
})
export class ActionCallComponent {}
